// 时间格式化函数
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return ''
  
  const d = new Date(date)
  if (isNaN(d.getTime())) return ''
  
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds)
}

// 数字格式化函数
export const formatNumber = (num, decimals = 2) => {
  if (num === null || num === undefined) return ''
  return Number(num).toFixed(decimals)
}

// 金额格式化函数
export const formatMoney = (amount, unit = '元') => {
  if (!amount && amount !== 0) return ''
  return Number(amount).toLocaleString() + unit
}